/* usage - for example:
 <pre debug-data param="formModel.yourData"></pre>
 or
 <pre><debug-data param="formModel.yourData"></debug-data></pre>
*/
(function() {

    var debugData = function() {
        return {
            restrict: "EA",
            scope: {
                param: "&" // one-way binding! -> &
            },
            template: "{{param() | json}}", // so we need a getter () for one-way binding
            link: function(scope, elem, attrs){
                console.log('DEBUG DATA:', attrs.param,',', typeof scope.param(),',', scope.param() );
                scope.$watch(
                    function(){
                        return scope.param();
                    },
                    function(newVal, oldVal){
                        if(newVal!==oldVal){
                            console.log('DEBUG DATA:', attrs.param,',', typeof scope.param(),',', scope.param() );
                        }
                    }, true
                );
            },
            replace: false
        }
    }
    angular.module('app').directive('debugData', debugData);

}());